/*
 * Stores user properties to local storage (only if browser support).
 * This will eventually be stored in server side
 */
export function getUserProperties(userId) {
  const userProperties = getUserPropertiesFromLocalStorage();
  return userProperties[userId] || {};
}

export function setUserProperty(userId, key, value) {
  const userProperties = getUserPropertiesFromLocalStorage();
  if (!userProperties[userId]) {
    userProperties[userId] = {};
  }
  userProperties[userId][key] = value;
  setUserPropertiesToLocalStorage(userProperties);
}

export const getSelectedOutlet = state => state.form.search.values.outletIds;

export const getSelectedFirstOutlet = state =>
  state.form.search.values.outletIds[0];

export const getFormSearchFilter = state => state.form.search.values;

export const isDisableOutletLevelForm = (featureFlag, detail) => {
  if (!featureFlag || !detail) return false;

  return featureFlag && detail && detail.has_business_level_entity;
};

export function resetUserProperties() {
  localStorage.removeItem('userProperties');
}

function getUserPropertiesFromLocalStorage() {
  const jsonString = localStorage.getItem('userProperties');
  return jsonString ? JSON.parse(jsonString) : {};
}

function setUserPropertiesToLocalStorage(userProperties) {
  localStorage.setItem('userProperties', JSON.stringify(userProperties));
}
